// OVERWATCH: utilidades compartidas.
var OW = (function () {
  var fmt = new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function copiar(boton, texto) {
    var listo = function () {
      var original = boton.textContent;
      boton.classList.add('ok'); boton.textContent = '✓';
      setTimeout(function () { boton.classList.remove('ok'); boton.textContent = original; }, 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).then(listo, function () { window.prompt('', texto); });
    } else {
      window.prompt('', texto);
    }
  }
  return { fmt: fmt, copiar: copiar, bsCopia: function (n) { return fmt.format(n).replace(/\./g, ''); } };
})();

// Ficha de producto: compra en 4 pasos (talla, datos, Pago Móvil con tasa BCV, confirmación con captura).
(function () {
  document.querySelectorAll('[data-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variantes]');
    var caja = root.querySelector('[data-compra]');
    if (!dataEl || !caja) return;
    var form = caja.querySelector('form');
    var variantes = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-agregar]');
    var precio = root.querySelector('[data-precio]');
    var variante = null;
    var tasa = parseFloat(caja.getAttribute('data-tasa')) || 0;
    var tasaFecha = caja.getAttribute('data-tasa-fecha') || '';
    var tasaAuto = false;

    function opcionesElegidas() {
      var valores = [];
      form.querySelectorAll('[data-opcion]').forEach(function (grupo) {
        var marcado = grupo.querySelector('input:checked');
        var select = grupo.querySelector('select');
        valores.push(marcado ? marcado.value : (select ? select.value : null));
      });
      return valores;
    }

    function actualizarVariante() {
      var valores = opcionesElegidas();
      var completa = valores.every(function (v) { return v; });
      variante = completa ? variantes.find(function (v) {
        return v.options.every(function (o, i) { return o === valores[i]; });
      }) : null;
      if (variantes.length === 1) variante = variantes[0];
      if (variante) {
        idInput.value = variante.id;
        boton.disabled = !variante.available;
        boton.textContent = variante.available ? boton.getAttribute('data-texto') : boton.getAttribute('data-agotado');
        if (precio) precio.innerHTML = variante.price_html;
      } else {
        idInput.value = '';
        boton.disabled = true;
        boton.textContent = boton.getAttribute('data-elige');
      }
      pintarMonto();
    }

    // Monto en bolívares con la tasa del día.
    var monto = form.querySelector('[data-monto-bs]');
    var copiaMonto = form.querySelector('[data-copiar-monto]');
    var textoTasa = form.querySelector('[data-tasa-texto]');
    var propMonto = form.querySelector('[data-prop-monto]');
    var propTasa = form.querySelector('[data-prop-tasa]');
    function pintarMonto() {
      if (!variante || !monto || !(tasa > 0)) return;
      var bs = Math.round(variante.price * tasa) / 100;
      monto.textContent = 'Bs. ' + OW.fmt.format(bs);
      monto.setAttribute('data-valor', bs);
      if (copiaMonto) copiaMonto.hidden = false;
      var usd = '$' + OW.fmt.format(variante.price / 100);
      var plantilla = caja.getAttribute(tasaAuto ? 'data-texto-tasa' : 'data-texto-tasa-manual');
      var texto = usd + ' · ' + plantilla.replace('[tasa]', OW.fmt.format(tasa));
      if (tasaFecha) texto += ' · ' + tasaFecha;
      textoTasa.textContent = texto;
      if (propMonto) propMonto.value = 'Bs. ' + OW.fmt.format(bs);
      if (propTasa) propTasa.value = OW.fmt.format(tasa) + (tasaFecha ? ' (' + tasaFecha + ')' : '');
    }
    if (copiaMonto) copiaMonto.addEventListener('click', function () {
      var n = parseFloat(monto.getAttribute('data-valor'));
      if (!isNaN(n)) OW.copiar(copiaMonto, OW.bsCopia(n));
    });

    if (caja.getAttribute('data-tasa-auto') === 'true' && window.fetch) {
      fetch('https://ve.dolarapi.com/v1/dolares/oficial')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          var t = parseFloat(d.promedio || d.venta || d.compra);
          if (!(t > 0)) return;
          tasa = t; tasaAuto = true;
          if (d.fechaActualizacion) {
            var f = new Date(d.fechaActualizacion);
            if (!isNaN(f)) tasaFecha = f.toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric' });
          }
          pintarMonto();
        })
        .catch(function () { /* se queda la tasa de respaldo */ });
    }

    form.querySelectorAll('[data-copiar]').forEach(function (b) {
      b.addEventListener('click', function () { OW.copiar(b, b.getAttribute('data-copiar')); });
    });

    // Pasos.
    var pasos = form.querySelectorAll('[data-paso]');
    var indicadores = form.querySelectorAll('[data-paso-ind]');
    function validar(panel) {
      var ok = true;
      panel.querySelectorAll('input[required]').forEach(function (c) {
        c.value = c.value.trim();
        c.classList.add('tocado');
        if (!c.checkValidity()) ok = false;
      });
      var error = panel.querySelector('[data-error]');
      if (error) error.hidden = ok;
      if (!ok) { var primero = panel.querySelector('input:invalid'); if (primero) primero.focus(); }
      return ok;
    }
    function ir(n) {
      pasos.forEach(function (p) { p.hidden = p.getAttribute('data-paso') !== String(n); });
      indicadores.forEach(function (i) { i.classList.toggle('activo', parseInt(i.getAttribute('data-paso-ind'), 10) <= n); });
      caja.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    var registrado = '';
    function registrarCliente() {
      var correo = form.querySelector('[data-cliente="email"]').value;
      if (!correo || correo === registrado) return;
      registrado = correo;
      var datos = new FormData();
      datos.append('form_type', 'customer');
      datos.append('utf8', '✓');
      datos.append('contact[email]', correo);
      datos.append('contact[first_name]', form.querySelector('[data-cliente="first_name"]').value);
      datos.append('contact[phone]', form.querySelector('[data-cliente="phone"]').value);
      datos.append('contact[tags]', 'comprador-web');
      fetch('/contact', { method: 'POST', body: datos, credentials: 'same-origin' }).catch(function () {});
    }
    form.querySelectorAll('[data-siguiente]').forEach(function (b) {
      b.addEventListener('click', function () {
        var destino = parseInt(b.getAttribute('data-siguiente'), 10);
        var panel = b.closest('[data-paso]');
        var actual = parseInt(panel.getAttribute('data-paso'), 10);
        if (destino > actual) {
          if (actual === 1 && (!variante || !variante.available)) return;
          if (!validar(panel)) return;
          if (actual === 2) registrarCliente();
        }
        ir(destino);
      });
    });

    // Captura del pago: nombre del archivo y vista previa.
    var captura = form.querySelector('[data-captura]');
    if (captura) captura.addEventListener('change', function () {
      var archivo = captura.files && captura.files[0];
      var nombre = form.querySelector('[data-captura-nombre]');
      var vista = form.querySelector('[data-captura-vista]');
      captura.closest('.subir').classList.toggle('lleno', !!archivo);
      if (archivo) {
        if (!nombre.getAttribute('data-original')) nombre.setAttribute('data-original', nombre.textContent);
        nombre.textContent = '✓ ' + archivo.name;
        if (vista && window.URL) { vista.src = URL.createObjectURL(archivo); vista.hidden = false; }
      } else {
        nombre.textContent = nombre.getAttribute('data-original') || nombre.textContent;
        if (vista) vista.hidden = true;
      }
    });

    // Enviar: se vacía el carrito para que el pedido sea solo esta bota y se pasa a la dirección de envío.
    var enviar = form.querySelector('[data-enviar]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variante || !validar(form.querySelector('[data-paso="4"]'))) return;
      enviar.disabled = true;
      enviar.textContent = enviar.getAttribute('data-enviando');
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
        .catch(function () {})
        .then(function () { form.submit(); });
    });

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-opcion]')) actualizarVariante();
    });
    actualizarVariante();
  });
})();

// Carrito: monto en Bs, botones de copiar y validación del pago antes de ir a los datos de envío.
(function () {
  var form = document.getElementById('form-carrito');
  if (!form) return;
  var fmt = OW.fmt, copiar = OW.copiar;

  form.querySelectorAll('[data-bs]').forEach(function (el) {
    var n = parseFloat(el.getAttribute('data-bs'));
    if (!isNaN(n)) el.textContent = 'Bs. ' + fmt.format(n);
  });

  form.querySelectorAll('[data-copiar]').forEach(function (b) {
    b.addEventListener('click', function () { copiar(b, b.getAttribute('data-copiar')); });
  });
  form.querySelectorAll('[data-copiar-bs]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseFloat(b.getAttribute('data-copiar-bs'));
      copiar(b, isNaN(n) ? '' : fmt.format(n).replace(/\./g, ''));
    });
  });

  var actualizar = form.querySelector('[data-actualizar]');
  form.querySelectorAll('[data-cantidad]').forEach(function (i) {
    i.addEventListener('change', function () { if (actualizar) actualizar.hidden = false; });
  });

  var error = form.querySelector('[data-error]');
  var campos = form.querySelectorAll('.pm--confirma input[required]');
  form.addEventListener('submit', function (e) {
    var boton = e.submitter;
    if (!boton || boton.name !== 'checkout') return;
    var ok = true;
    campos.forEach(function (c) {
      c.value = c.value.trim();
      c.classList.add('tocado');
      if (!c.checkValidity()) ok = false;
    });
    if (!ok) {
      e.preventDefault();
      if (error) error.hidden = false;
      var primero = form.querySelector('.pm--confirma input:invalid');
      if (primero) primero.focus();
    }
  });
})();
